import type {
  LiveDataSource,
  LiveOracleSample,
  LiveOracleStatus,
} from "../core/contracts";

const UNCONFIGURED: LiveOracleStatus = {
  state: "unconfigured",
  label: "Live Oracle · later",
  detail:
    "The adapter contract is ready. No database endpoint, credentials, or MCP service is shipped to the browser.",
};

export class LiveOracleStubSource implements LiveDataSource {
  status(): LiveOracleStatus {
    return UNCONFIGURED;
  }

  async connect(): Promise<LiveOracleStatus> {
    return UNCONFIGURED;
  }

  async disconnect(): Promise<void> {
    return;
  }

  async sample(): Promise<LiveOracleSample | null> {
    return null;
  }
}
